module.exports = {
  slots: [
    {
      slotId: 'menu-bar',
      components: [
        {
          widgetId: 'MenuBar',
          props: {
            second_set: [
              {
                subnav: [
                  {
                    label: 'Contact Us',
                    url: '/contact-us'
                  }, {
                    label: 'FAQ',
                    url: '/faq'
                  }
                ],
                label: 'Support'
              },
              {
                label: 'Sign In',
                url: '/login',
                loggedInLabel: 'My FF'
              }
            ],
            first_set: [
              {
                subnav: [],
                label: 'FF 91',
                url: '/ff-91'
              }, {
                subnav: [],
                label: 'FFZERO1',
                url: '/ffzero1'
              }, {
                subnav: [],
                label: 'Formula E',
                url: '/formula-e'
              }, {
                subnav: [],
                label: 'FUTURESIGHT',
                url: '/futuresight'
              }, {
                subnav: [
                  {
                    label: 'Our Company',
                    url: '/our-company'
                  }, {
                    label: 'Formula E',
                    url: '/formula-e'
                  }, {
                    label: 'Careers',
                    url: '/careers'
                  }, {
                    label: 'Press Room',
                    url: '/press'
                  }
                ],
                url: '',
                label: 'About Us'
              }
            ],
            logo_link: '/',
            color_theme: 'LIGHT',
            scroll_effect: false
          }
        }
      ]
    }, {
      slotId: 'left-col',
      components: []
    }, {
      slotId: 'right-col',
      components: []
    }, {
      slotId: 'header-right',
      components: []
    }, {
      slotId: 'footer',
      components: [
        {
          widgetId: 'Footer',
          props: {
            items: [
              { url: '/sitemap', label: 'Sitemap' },
              { url: '/privacy-policy', label: 'Privacy & Legal' },
              { url: '/contact-us', label: 'Contact Us' }
            ],
            regions: [
              {
                value: 'US',
                imgUrl: 'https://genesis-cdn.ff.com/icon-en.png'
              }, {
                value: 'CN',
                imgUrl: 'https://genesis-cdn.ff.com/icon-china.png'
              }
            ],
            socialLinks: [
              { url: 'https://linkedin.com', icon: 'ff-icon-social-linkedin' },
              { url: 'https://youtube.com', icon: 'ff-icon-social-youtube' },
              { url: 'https://twitter.com', icon: 'ff-icon-social-twitter' },
              { url: 'https://facebook.com', icon: 'ff-icon-social-facebook' },
              { url: 'https://instagram.com', icon: 'ff-icon-social-instagram' }
            ],
            copyright: {
              text: 'Faraday&Future Inc. The Faraday Future name and logo are trademarks of Faraday&Future Inc. All rights reserved.'
            }
          }
        }
      ]
    }
  ],
  templateSettings: {
    region: 'US',
    section: 'FUTURESIGHT',
    url: '/us/futuresight/first-po',
    title: 'Intelligent Materials: Evolving Car Design & Sustainability',
    description: 'Faraday Future (FF) has signed a lease on its new manufacturing facility, and began the process of clean-up…',
    heroImageUrl: 'https://genesis-cdn.ff.com/our_company/01_people/ourpeople-07.jpg',
    featured: true,
    published_at: '2017-08-19T19:51:09.878Z',
    published_by: 'FF Team',
    tags: [
      { tag: 'Technology' },
      { tag: 'Community' },
      { tag: 'Company' }
    ],
    social_share: [
      { url: 'https://www.linkedin.com/shareArticle?mini=true&url={page url}&title={article title}&summary={short description}', icon: 'ff-icon-social-linkedin' },
      { url: 'https://twitter.com/share?url={URL}&text={article title} @FaradayFuture', icon: 'ff-icon-social-twitter' },
      { url: 'https://www.facebook.com/sharer/sharer.php?u={URL}', icon: 'ff-icon-social-facebook' },
      { url: 'mailto:?subject={article title}&body={URL}', icon: 'ff-icon-mail' },
      { url: 'http://service.weibo.com/share/share.php?url={URL}&title={article title} @FaradayFuture&appkey=1343713053&pic=&searchPic=false', icon: 'ff-icon-social-weibo' },
      { url: '{URL}', icon: 'ff-icon-social-wechat' }
    ]
  }
};
